import { ToastType } from './types';

export const getIconByToastType = (type: ToastType): string => {
  switch (type) {
    case ToastType.Error:
      return 'close-small';
    case ToastType.Success:
    default:
      return 'check-v2';
  }
};
